module.exports = __webpack_public_path__ + "87f1e403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon-send-document.png
// module id = 1538
// module chunks = 0